var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"22","height":"14","rx":"3","fill":"black","stroke":"black","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("g",{"clipPath":"url(#clip0_9965_34793)","key":1},React.createElement("path",{"d":"M0 2L10.844 9.68114C11.5366 10.1717 12.4634 10.1717 13.156 9.68114L24 2","stroke":"white","strokeWidth":"1.5"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_9965_34793"},React.createElement("rect",{"width":"20","height":"12","fill":"white","transform":"translate(2 2)"})))]);
}

Email.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = Email;

Email.default = Email;
